module.exports = __webpack_public_path__ + "media/conmex/calculator-f82fe8c7.png";